var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9997 13.9134C27.967 11.229 27.1725 8.60994 25.7098 6.36463C24.2471 4.11933 22.1773 2.3413 19.7441 1.23996C17.3106 0.138616 14.6152 -0.240173 11.9751 0.148178C9.33498 0.536546 6.86013 1.67587 4.84203 3.43203C2.8239 5.18817 1.34656 7.48799 0.583978 10.0606C-0.178589 12.6333 -0.194655 15.3715 0.537706 17.9531C1.27007 20.5346 2.72033 22.8517 4.71772 24.6317C6.71509 26.4117 9.17641 27.5804 11.8118 28V18.0161H8.31169V13.9134H11.8118V10.7967C11.7308 10.0721 11.8088 9.33832 12.0405 8.6473C12.2722 7.95628 12.6518 7.32485 13.1525 6.79757C13.6532 6.27027 14.2627 5.85998 14.9382 5.59566C15.6138 5.33133 16.3388 5.21939 17.0619 5.26778C18.1116 5.28224 19.1588 5.37642 20.1945 5.54951V9.07117H18.4445C18.1428 9.03287 17.8362 9.0633 17.5477 9.16019C17.2592 9.25709 16.996 9.41798 16.7775 9.63097C16.5591 9.84396 16.3911 10.1036 16.286 10.3907C16.1806 10.6779 16.1409 10.9851 16.1694 11.2898V13.9486H20.0545L19.4245 18.0513H16.1869V27.912C19.4943 27.3856 22.5048 25.684 24.672 23.1156C26.8393 20.5473 28.0199 17.2826 27.9997 13.9134Z",
    fill: "#20C3FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebookIcon.3cb5da1c0fd999a190d3b87ecdeea28b.svg";
export { ForwardRef as ReactComponent };